import {
  Stethoscope,
  Syringe,
  Bug,
  Cpu,
  PlaneTakeoff,
  ClipboardList,
  FlaskConical,
  Activity,
  ScanLine,
  Microscope,
  Scissors,
  HeartPulse,
  Smile,
  Ambulance,
  ClipboardCheck,
  Salad,
  BedDouble,
  HeartHandshake,
  PackageOpen,
  ShoppingBag,
  Bone,
  Baby,
  Hourglass,
  Sparkles,
  Soup,
} from "lucide-react";

export const CATEGORIAS = [
  { slug: "consultas", nome: "Consultas", titulo: "O cuidado começa na consulta" },
  { slug: "especialidade", nome: "Consultas de Especialidade", titulo: "Áreas clínicas dedicadas" },
  { slug: "diagnostico", nome: "Diagnóstico", titulo: "Saber o que se passa" },
  { slug: "cirurgia", nome: "Cirurgia", titulo: "Intervir com segurança" },
  { slug: "urgencia", nome: "Urgências", titulo: "Quando o tempo conta" },
  { slug: "outros", nome: "Outros Cuidados", titulo: "Para todos os momentos" },
  { slug: "petshop", nome: "PetShop", titulo: "Tudo o que precisam em casa" },
];

export const SERVICOS = [
  // Consultas gerais
  {
    slug: "consulta-medicina-geral",
    categoria: "consultas",
    nome: "Consulta de Medicina Geral",
    icon: Stethoscope,
    descricao:
      "Avaliação clínica geral do estado de saúde do seu animal, com diagnóstico e plano terapêutico.",
    duracao: 30,
    online: true,
  },
  {
    slug: "consulta-pediatria",
    categoria: "consultas",
    nome: "Consulta de Pediatria",
    icon: Baby,
    descricao:
      "Acompanhamento dedicado a cachorros e gatinhos, com plano vacinal, desparasitação e nutrição.",
    duracao: 30,
    online: true,
  },
  {
    slug: "consulta-pre-cirurgica",
    categoria: "consultas",
    nome: "Consulta Pré-cirúrgica",
    icon: ClipboardCheck,
    descricao:
      "Avaliação antes de cirurgia: exames, riscos anestésicos e preparação do animal.",
    duracao: 30,
    online: true,
  },
  {
    slug: "consulta-pos-cirurgica",
    categoria: "consultas",
    nome: "Consulta Pós-cirúrgica",
    icon: HeartPulse,
    descricao:
      "Reavaliação e cuidados após cirurgia para garantir uma recuperação tranquila.",
    duracao: 20,
    online: true,
  },
  {
    slug: "consulta-geriatrica",
    categoria: "consultas",
    nome: "Consulta Geriátrica",
    icon: Hourglass,
    descricao:
      "Acompanhamento sénior com avaliação completa de doenças crónicas e qualidade de vida.",
    duracao: 30,
    online: true,
  },
  {
    slug: "consulta-vacinacao",
    categoria: "consultas",
    nome: "Consulta de Vacinação",
    icon: Syringe,
    descricao:
      "Protocolo vacinal completo para cão, gato e outras espécies, adaptado à idade e estilo de vida.",
    duracao: 20,
    online: true,
  },

  // Especialidades
  {
    slug: "consulta-especialidade",
    categoria: "especialidade",
    nome: "Consulta de Especialidade",
    icon: Sparkles,
    descricao:
      "Atendimento dedicado em áreas específicas para casos que exigem conhecimento aprofundado.",
    duracao: 40,
    online: false,
  },
  {
    slug: "consulta-dermatologia",
    categoria: "especialidade",
    nome: "Consulta de Dermatologia",
    icon: Sparkles,
    descricao:
      "Diagnóstico e tratamento de problemas de pele, alergias e dermatites.",
    duracao: 40,
    online: false,
  },
  {
    slug: "consulta-estomatologia",
    categoria: "especialidade",
    nome: "Consulta de Estomatologia",
    icon: Smile,
    descricao:
      "Avaliação e cuidados da cavidade oral e dentária do seu animal.",
    duracao: 40,
    online: false,
  },
  {
    slug: "consulta-gastroenterologia",
    categoria: "especialidade",
    nome: "Consulta de Gastroenterologia",
    icon: Soup,
    descricao:
      "Diagnóstico e tratamento de problemas digestivos, intestinais e hepáticos.",
    duracao: 40,
    online: false,
  },

  // Diagnóstico
  {
    slug: "analises",
    categoria: "diagnostico",
    nome: "Análises clínicas",
    icon: FlaskConical,
    descricao:
      "Hemogramas, bioquímicas, urinálises e outros testes laboratoriais.",
    duracao: null,
    online: false,
  },
  {
    slug: "ecografia",
    categoria: "diagnostico",
    nome: "Ecografia",
    icon: Activity,
    descricao:
      "Exame de imagem não invasivo para avaliação de órgãos internos.",
    duracao: null,
    online: false,
  },
  {
    slug: "raio-x",
    categoria: "diagnostico",
    nome: "Raio-X",
    icon: ScanLine,
    descricao:
      "Exames radiológicos para diagnóstico ortopédico, torácico e abdominal.",
    duracao: null,
    online: false,
  },
  {
    slug: "citologia-biopsia",
    categoria: "diagnostico",
    nome: "Citologia e biópsias",
    icon: Microscope,
    descricao:
      "Análise de amostras para diagnóstico oncológico e dermatológico.",
    duracao: null,
    online: false,
  },

  // Cirurgia
  {
    slug: "cirurgia-geral",
    categoria: "cirurgia",
    nome: "Cirurgia geral e de tecidos moles",
    icon: Scissors,
    descricao:
      "Intervenções cirúrgicas com equipamento moderno e protocolos de segurança rigorosos.",
    duracao: null,
    online: false,
  },
  {
    slug: "esterilizacao",
    categoria: "cirurgia",
    nome: "Esterilização e castração",
    icon: HeartPulse,
    descricao:
      "Procedimentos preventivos com recuperação rápida e acompanhamento próximo.",
    duracao: null,
    online: false,
  },
  {
    slug: "cirurgia-dentaria",
    categoria: "cirurgia",
    nome: "Cirurgia dentária",
    icon: Smile,
    descricao: "Destartarização e extrações com anestesia segura.",
    duracao: null,
    online: false,
  },

  // Urgências
  {
    slug: "urgencia",
    categoria: "urgencia",
    nome: "Atendimento de urgência",
    icon: Ambulance,
    descricao:
      "Resposta rápida em horário de funcionamento. Para emergências, contacte primeiro por telefone.",
    duracao: null,
    online: false,
  },

  // Outros
  {
    slug: "nutricao",
    categoria: "outros",
    nome: "Aconselhamento nutricional",
    icon: Salad,
    descricao:
      "Planos alimentares adaptados à idade, raça e condição clínica.",
    duracao: 30,
    online: true,
  },
  {
    slug: "desparasitacao",
    categoria: "outros",
    nome: "Desparasitação interna e externa",
    icon: Bug,
    descricao:
      "Proteção contra parasitas internos e externos com produtos adequados a cada animal.",
    duracao: 15,
    online: true,
  },
  {
    slug: "microchip",
    categoria: "outros",
    nome: "Identificação eletrónica (microchip)",
    icon: Cpu,
    descricao:
      "Implantação de microchip e registo na base de dados nacional, obrigatório para cães.",
    duracao: 15,
    online: true,
  },
  {
    slug: "passaporte",
    categoria: "outros",
    nome: "Passaporte do animal",
    icon: PlaneTakeoff,
    descricao:
      "Emissão e atualização do passaporte para viagens internacionais.",
    duracao: 30,
    online: false,
  },
  {
    slug: "hospitalizacao",
    categoria: "outros",
    nome: "Hospitalização de curta duração",
    icon: BedDouble,
    descricao:
      "Internamento para tratamentos que requerem observação.",
    duracao: null,
    online: false,
  },
  {
    slug: "eutanasia",
    categoria: "outros",
    nome: "Eutanásia humanitária e apoio ao luto",
    icon: HeartHandshake,
    descricao: "Acompanhamento sensível num momento difícil.",
    duracao: null,
    online: false,
  },

  // PetShop
  {
    slug: "racoes",
    categoria: "petshop",
    nome: "Rações premium",
    icon: PackageOpen,
    descricao:
      "Marcas selecionadas para cão e gato, incluindo dietas veterinárias.",
    duracao: null,
    online: false,
  },
  {
    slug: "acessorios",
    categoria: "petshop",
    nome: "Acessórios",
    icon: ShoppingBag,
    descricao: "Coleiras, trelas, casotas, transportadoras.",
    duracao: null,
    online: false,
  },
  {
    slug: "brinquedos",
    categoria: "petshop",
    nome: "Brinquedos",
    icon: Bone,
    descricao: "Brinquedos seguros e estimulantes.",
    duracao: null,
    online: false,
  },
];

export const servicosPorCategoria = (slug) =>
  SERVICOS.filter((s) => s.categoria === slug);
